'use client'
import { noto_sans } from '@/globalConstants'
import React from 'react'
import Link from 'next/dist/client/link'
const NavBar = ({ BASE_CLASS, pathname }: { BASE_CLASS: string, pathname: string }) => {
    return (
        <div className={`${BASE_CLASS}__nav-bar ${BASE_CLASS === "header" && 'hidden'} duration-500  lg:block  `}>
            <ul className={`${BASE_CLASS}__nav-links   flex flex-wrap justify-center lg-justify-end items-center gap-[1rem]  font-bold  ${noto_sans.className} tracking-[0.05rem] text-white text-[1rem] `}>
                <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                hover:text-[#ebe793] hover:text-shadow 
                                                transition delay-150 duration-200 
                                                ease-in-out           
                                             `}>
                    <Link href="/">Home</Link>
                </li>

                <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                    hover:text-[#ebe793] hover:text-shadow 
                                                    transition delay-150 duration-200 
                                                    ease-in-out
                                                    `}>
                    <Link href="/learn-more-web">Learn More</Link>
                </li>
                <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                                                    hover:text-[#ebe793] hover:text-shadow 
                                                    transition delay-150 duration-200 
                                                    ease-in-out
                                                    `}>
                    <Link href="/articles">Articles</Link>
                </li>
                <li className={`${BASE_CLASS}__nav-links__link cursor-pointer 
                 hover:text-[#ebe793] hover:text-shadow 
                                                    transition delay-150 duration-200 
                                                    ease-in-out
                `}>
                    <Link href={pathname + '#contact'}>Contact Us</Link>
                </li>
                <li className={`${BASE_CLASS}__nav-links__link cursor-pointer border-solid ml-8   `}>
                    <Link href={'/apps'}>
                        <button className={`${BASE_CLASS}__nav-links__contact-us 
                                                    rounded-[100px] 
                                                    transition delay-150 duration-200 
                                                    ease-in-out  
                                                     ${BASE_CLASS === "header" ? ` hover:text-[#fe9b35] 
                                                      bg-[#FFFFFF] text-[#1D4749] px-4 py-2 border-solid
                                                       border-[#FFFFFF] border-2 hover:border-[#fe9b35] 
                                                       outline-offset-2 outline-4`: `
                                                       hover:text-[#ebe793] hover:text-shadow`}`}>

                            App
                        </button>
                    </Link>
                </li>

            </ul>
        </div>
    )
}
export default NavBar